














































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { APP_CONFIG } from '@/config/app-config';
import { Cart } from '@/models/cart';
@Component({})
export default class CartItem extends Vue {
    @Prop({default: null})
    private cart!: Cart;

    @Prop({default: 0})
    private index!: number;

    private isCheckA = false;
    private isCheckB = false;
    private guaranteeType = 0;
    @Watch('isCheckA', { immediate: true, deep: true })
    private async watchIsCheckA() {
        if (this.isCheckA) {
            this.isCheckB = false;
            this.cart.isCheckA = true;
            this.cart.IsCheck = true;
            this.cart.CheckFeeType = this.cart.isCheckA ? 1 : this.cart.isCheckB ? 2 : 0;
            this.$emit('eventUpdateConfirm', {});
        }
    }

    @Watch('isCheckB', { immediate: true, deep: true })
    private async watchIsCheckB() {
        if (this.isCheckB) {
            this.isCheckA = false;
            this.cart.isCheckB = true;
            this.cart.IsCheck = true;
            this.cart.CheckFeeType = this.cart.isCheckA ? 1 : this.cart.isCheckB ? 2 : 0;
            this.$emit('eventUpdateConfirm', {});
        }
    }

    @Watch('guaranteeType', { immediate: true, deep: true })
    private async watchGuaranteeType() {
        this.cart.guaranteeType = this.guaranteeType;
        this.cart.GuaranteeType = this.guaranteeType;
        this.$emit('eventUpdateConfirm', {});
    }

    get feeGuarantee() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].feeGuarantee;
    }

    
}
